import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { FiltersPanelService } from './filters-panel.service';
import { Filter, FilterItem, FilterType } from './models/filter';
import { Observable } from 'rxjs';
import { tinykeys } from 'tinykeys';
import { DateRange } from '@angular/material/datepicker';
import { DateSelectingStrategy } from './models/strategy';
import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../ph-button/ph-button.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { PhLoaderComponent } from '../ph-loader/ph-loader.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { TreeFilterComponent } from './tree-filter/tree-filter.component';
import { PhDatepickerComponent } from '../ph-datepicker/ph-datepicker/ph-datepicker.component';

export enum PanelDirection {
	Left = 'left',
	Right = 'right'
}

export const ALL_FILTER_ITEM: FilterItem = {
	id: -1,
	value: 'ALL',
	opened: true,
	loading: false,
	hasChildren: true
}

@Component({
    selector: 'app-filters-panel',
    templateUrl: './filters-panel.component.html',
    styleUrls: ['./filters-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
	imports: [
		SHARED_MODULES,
		PhButtonComponent,
		PhDatepickerComponent,
		PhIconComponent,
		PhIconWrapperComponent,
		PhLoaderComponent,
		TreeFilterComponent
	],
    standalone: true
})
export class FiltersPanelComponent implements OnInit {

	@Input() duration: number = 0.25;
	@Input() panelWidth: number = window.innerWidth;
	@Input() direction: PanelDirection = PanelDirection.Right;
	@Input() hasBackdrop: boolean = false;
	@Input() fullHeight: boolean = false;

	@ViewChild('accordion') accordion: MatAccordion;

	showPanel: Observable<boolean>;
	filterType = FilterType;
	filters: Array<Filter> = [];
	tinyKeysSubscription: any;

	constructor(
		private ref: ChangeDetectorRef,
		private panelService: FiltersPanelService
	) {}

	ngOnInit(): void {
		this.showPanel = this.panelService.getShowPanel();
		this.showPanel.subscribe((show: boolean) => {
			if (show) {
				this.tinyKeysSubscription = tinykeys(window, {
					'Escape': (event: KeyboardEvent) => {
						event.preventDefault();

						this.onPanelClose();
					}
				});
			} else {
				if (this.tinyKeysSubscription) this.tinyKeysSubscription();
			}
		});
		this.panelService.getFilters().subscribe((filters: Array<Filter>) => {
			this.filters = filters.sort((a: Filter, b: Filter) => a.displayOrder - b.displayOrder);
		});
		this.panelService.getApplyPanel().subscribe((apply: boolean) => {
			if (!apply) {
				this.filters.forEach((filter: Filter) => {
					if (filter.type == FilterType.Radio) {
						filter.selectingStrategy.clear();
						if (filter.afterCheck) filter.afterCheck(this.filters);
					}
					if (filter.type == FilterType.Date) filter.selectingStrategy = new DateSelectingStrategy(filter.data);
				});
			}
		});
	}

	onPanelClose(): void {
		if (this.accordion) this.accordion.closeAll();
		this.panelService.setShowPanel(false);
	}

	onPanelCancel(): void {
		this.accordion.closeAll();
		this.panelService.setApplyPanel(false);
		this.panelService.setShowPanel(false);
	}

	onPanelApply(): void {
		this.accordion.closeAll();
		this.panelService.setApplyPanel(true);
		this.panelService.setShowPanel(false);
	}

	onRadioChange(filter: Filter, option: FilterItem): void {
		filter.selectingStrategy.setSelected(option);
		if (filter.afterCheck) filter.afterCheck(this.filters);
	}

	onScrolled(): void {
		this.ref.detectChanges();
	}

	getPanelStyle(showPanel: boolean): any {
		let panelStyle: any = {};

		panelStyle.transition = `${this.direction} ${this.duration}s, visibility ${this.duration}s`;
		panelStyle.width = `${this.panelWidth}px`;
		panelStyle[this.direction] = `${showPanel ? 0 : (this.panelWidth * -1)}px`;

		return panelStyle;
	}

	onCheck(filter: Filter) {
		if (filter.afterCheck) filter.afterCheck(this.filters);
	}

	onSearch() {
		this.ref.detectChanges();
	}

	setDate(filter: Filter, filterItem: FilterItem, date: DateRange<Date>): void {
		const newFilterItem: FilterItem = {
			id: filterItem.id,
			value: new DateRange<Date>(
				!isNaN(date.start.getTime()) ? date.start : null,
				!isNaN(date.end.getTime()) ? date.end: null
			)
		};
		(filter.selectingStrategy as DateSelectingStrategy).setSelected(newFilterItem);
	}
}
